<template>
    <ul ref="container">
        <slot></slot>
    </ul>
</template>

<script setup>
    const props = defineProps({
        options: { required: false, type: Object },
    })

    const container = ref();

    const init = () => {
        if (container.value.offsetWidth) {
            $(container.value).slick(Object.assign({}, {
                dots: true,
                arrows: false,
                autoplay: false,
                autoplaySpeed: 3000
            }, props.options));
        } else {
            setTimeout(init);
        }
    };

    onMounted(init);

    onUnmounted(() => {
        $(container.value).slick("unslick");
    });
</script>
